<div *ngIf="isViewReady">

	<ng-container *ngIf="certificateFrom && (certificate?.uuid && certificate?.status != 'revoked'); else noCertificate">
		<div class="fatoorah-show active">
			<ul>
				<li *ngIf="certificate?.is_compliance">
					<div class="switch-wrapper" >
						<div class="switch">
							<input type="checkbox" [checked]="!certificate?.is_enable" (change)="updateStatus(certificate?.uuid, $event)" >
							<span class="slider round"></span>
						</div>
						<label class="fs-5" for="auto-renew" *ngIf="certificate?.is_enable"><strong i18n="@@ts.enable">Enable</strong>&nbsp;&nbsp;</label> 
						<label class="fs-5" for="auto-renew" *ngIf="!certificate?.is_enable"><strong i18n="@@ts.disable">Disable</strong>&nbsp;&nbsp;</label> 
					</div>
				</li>

				<li *ngIf="certificate?.is_compliance && certificate?.is_production">
					<div class="details d-flex gap-3">
						<span class="tu-btn pink transparent" i18n="@@zatca.renew_csid" (click)="generateComplianceCertificate('renew')" >Renew CSID</span>
						<span class="tu-btn pink transparent text-nowrap" i18n="@@zatca.revoke_certificate" *ngIf="certificate?.status != 'revoked'" (click)="revokeCertificate(certificate?.uuid)" >Revoke Certificate</span>
					</div>
				</li>

				<!-- is_compliance -->
				<li *ngIf="certificate?.is_certificate_build">
					<span class="name" i18n="@@zatca.compliance_certificate_generated">Compliance Certificate : </span>
					<div class="details d-flex gap-3">
						<ng-container  *ngIf="certificate?.is_compliance; else notComplianceGenerated">
							<span class="tu-btn blue" i18n="@@ts.generated" >Generated</span>
							<span class="tu-btn pink transparent text-nowrap" i18n="@@zatca.production_onboarding_csid" *ngIf="!certificate?.is_production" (click)="generateOnboardingCSIDCertificate()" >Production CSID (Onboarding)</span>
						</ng-container>
						<ng-template #notComplianceGenerated>
							<span class="tu-btn pink transparent" i18n="@@zatca.generate_compliance_certificate" (click)="generateComplianceCertificate('compliance')">Generate Compliance Certificate</span>
							<a href="/images/zatca-fatoora.png" target="_blank" class="compliance_certificate-logo" data-toggle="tooltip" data-placement="top" i18n-title="@@zatca.how_onboard_invoicing_solution_through_fatoora_portal" title="How to onboard to e-invoicing solution through 'Fatoora' portal?">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26px" height="26px">
									<path d="M 13 1.1875 C 6.476563 1.1875 1.1875 6.476563 1.1875 13 C 1.1875 19.523438 6.476563 24.8125 13 24.8125 C 19.523438 24.8125 24.8125 19.523438 24.8125 13 C 24.8125 6.476563 19.523438 1.1875 13 1.1875 Z M 15.460938 19.496094 C 14.851563 19.734375 14.367188 19.917969 14.003906 20.042969 C 13.640625 20.167969 13.222656 20.230469 12.742188 20.230469 C 12.007813 20.230469 11.433594 20.050781 11.023438 19.691406 C 10.617188 19.335938 10.414063 18.878906 10.414063 18.324219 C 10.414063 18.109375 10.429688 17.890625 10.460938 17.667969 C 10.488281 17.441406 10.539063 17.191406 10.605469 16.90625 L 11.367188 14.21875 C 11.433594 13.960938 11.492188 13.71875 11.539063 13.488281 C 11.585938 13.257813 11.605469 13.046875 11.605469 12.855469 C 11.605469 12.515625 11.535156 12.273438 11.394531 12.140625 C 11.25 12.003906 10.980469 11.9375 10.582031 11.9375 C 10.386719 11.9375 10.183594 11.96875 9.976563 12.027344 C 9.769531 12.089844 9.59375 12.148438 9.445313 12.203125 L 9.648438 11.375 C 10.144531 11.171875 10.621094 11 11.078125 10.855469 C 11.53125 10.710938 11.964844 10.636719 12.367188 10.636719 C 13.097656 10.636719 13.664063 10.816406 14.058594 11.167969 C 14.453125 11.519531 14.652344 11.980469 14.652344 12.542969 C 14.652344 12.660156 14.640625 12.867188 14.613281 13.160156 C 14.585938 13.453125 14.535156 13.722656 14.460938 13.972656 L 13.703125 16.652344 C 13.640625 16.867188 13.585938 17.113281 13.535156 17.386719 C 13.488281 17.660156 13.464844 17.871094 13.464844 18.011719 C 13.464844 18.367188 13.542969 18.613281 13.703125 18.742188 C 13.859375 18.871094 14.136719 18.933594 14.53125 18.933594 C 14.714844 18.933594 14.921875 18.902344 15.15625 18.839844 C 15.386719 18.773438 15.554688 18.71875 15.660156 18.667969 Z M 15.324219 8.617188 C 14.972656 8.945313 14.546875 9.109375 14.050781 9.109375 C 13.554688 9.109375 13.125 8.945313 12.769531 8.617188 C 12.414063 8.289063 12.238281 7.890625 12.238281 7.425781 C 12.238281 6.960938 12.417969 6.558594 12.769531 6.226563 C 13.125 5.894531 13.554688 5.730469 14.050781 5.730469 C 14.546875 5.730469 14.972656 5.894531 15.324219 6.226563 C 15.679688 6.558594 15.855469 6.960938 15.855469 7.425781 C 15.855469 7.890625 15.679688 8.289063 15.324219 8.617188 Z" />
								</svg>
							</a>
						</ng-template>
					</div>
				</li>

				<li>
					<span class="name" i18n="@@zatca.certificate_generated">Certificate Generated : </span>
					<div class="details d-flex gap-3">
						<ng-container *ngIf="certificate?.is_certificate_build; else notGenerated">
							<span class="tu-btn blue" i18n="@@ts.generated" >Generated</span>
							<span class="tu-btn pink transparent text-nowrap" i18n="@@zatca.update_certificate" *ngIf="!certificate?.is_production" (click)="generateCertificate()" >Update Certificate</span>
						</ng-container>
						<ng-template #notGenerated>
							<span class="tu-btn pink transparent" i18n="@@zatca.generate_certificate" (click)="generateCertificate()">Generate Certificate</span>
						</ng-template>
					</div>
				</li>

				<li>
					<span class="name" i18n="@@zatca.status">Status :</span>
					<div class="details">
						<span class="tu-btn yellow" *ngIf="certificate.status == 'pending'" i18n="@@ts.pending">Pending</span>
						<span class="tu-btn yellow" *ngIf="certificate.status == 'initiated'" i18n="@@ts.initiated">Initiated</span>
						<span class="tu-btn blue" *ngIf="certificate.status == 'active'" i18n="@@ts.active" >Active</span>
						<span class="tu-btn red" *ngIf="certificate.status == 'revoked'" i18n="@@ts.revoked" >Revoked</span>
						<span class="tu-btn red" *ngIf="certificate.status == 'inactive'" i18n="@@ts.inactive" >Inactive</span>
					</div>
				</li>

				<li>
					<span class="name" i18n="@@zatca.organization_id">VAT Number</span>
					<span class="details">{{ certificate?.organization_id }}</span>
				</li>
				<!-- <li>
					<span class="name" i18n="@@zatca.solution_name">Solution Name</span>
					<span class="details">{{ certificate?.solution_name }}</span>
				</li>
				<li>
					<span class="name" i18n="@@zatca.model">Model</span>
					<span class="details">{{ certificate?.model }}</span>
				</li> -->
				<li>
					<span class="name" i18n="@@zatca.serial_number">Serial Number</span>
					<span class="details">{{ certificate?.solution_name }} | {{ certificate?.model }} | {{ certificate?.serial_number }}</span>
				</li>
				<li>
					<span class="name" i18n="@@zatca.company_name">Company Name</span>
					<span class="details">{{ certificate?.common_name }}</span>
				</li>
				<li>
					<span class="name" i18n="@@zatca.organization_name">Organization Name</span>
					<span class="details">{{ certificate?.organization_name }}</span>
				</li>
				<li>
					<span class="name" i18n="@@zatca.organizational_unit_name">Organization Unit Name</span>
					<span class="details">{{ certificate?.organizational_unit_name }}</span>
				</li>
				<li>
					<span class="name" i18n="@@zatca.address">Address</span>
					<span class="details">{{ certificate?.address }}</span>
				</li>
				<li>
					<span class="name" i18n="@@zatca.country_name">Country</span>
					<span class="details">{{ certificate?.country_name }}</span>
				</li>
				<li>
					<span class="name" i18n="@@zatca.business_category">Business Category</span>
					<span class="details">{{ certificate?.business_category }}</span>
				</li>
				<!-- <li>
					<span class="name" i18n="@@zatca.invoice_type">Invoice Type</span>
					<span class="details">{{ certificate?.invoice_type }}</span>
				</li>
				<li>
					<span class="name" i18n="@@zatca.production">Production</span>
					<span class="details">{{ certificate?.production }}</span>
				</li> -->
			</ul>
		</div>
	</ng-container>

	<ng-template #noCertificate>
		<form class="general-information" [formGroup]="certificateBuilderForm" (ngSubmit)="onSubmit()" novalidate>

			<h3 class="white">
				<span i18n="@@zatca.generate_certificate">Generate Certificate</span>
			</h3>

			<div class="mixed-fields">
				<fieldset class="organization-id oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.organization_id?.dirty) && f.organization_id.errors }">
					<div class="d-flex gap-2 align-items-center pointer">
						<ng-container i18n="@@zatca.organization_id">VAT number</ng-container><span class="req-star">*</span>
						<div class="tooltip_wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
								<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div class="help_tooltip_text">
								<ng-container i18n="@@zatca.organization_id_tooltip">
									VAT Registration Number, the VAT number must be 15 digits, starting andending with 3.
								</ng-container>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
								</svg>
							</div>
						</div>
					</div>
					<input type="text" formControlName="organization_id" placeholder="3XXXXXXXXXXXXX3" maxlength="15" class="organization-id" />
					<span class="field-error" *ngIf="(isSubmitted || f.organization_id.dirty) && f.organization_id.errors?.required" i18n="@@error.required" >Required</span>
					<span class="field-error" *ngIf="(isSubmitted || f.organization_id.dirty) && f.organization_id.errors?.pattern" i18n="@@validation.errors.enter_valid_organization_id">Must be 15 digits, start with 3 and end with 3</span>
					<span class="field-error" *ngIf="isSubmitted && f.organization_id.errors?.serverError">{{ f.organization_id.errors?.serverError }}</span>
				</fieldset>

				<!-- <fieldset class="serial-number oneThird" [ngClass]="{ 'has-error': (isSubmitted || (f.serial_number?.dirty || f.solution_name.dirty || f.model.dirty)) && (f.serial_number.errors || f.solution_name.errors || f.model.errors) }">
					<div class="d-flex gap-2 align-items-center pointer">
						<ng-container i18n="@@zatca.serial_number">Serial Number</ng-container><span class="req-star">*</span>
						<div class="tooltip_wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
								<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div class="help_tooltip_text serial_number">
								<ng-container i18n="@@zatca.serial_number_tooltip">
									1. Solution Name: Name of the software or system generating the invoice.<br/>
									2. Model: Model name of the device or software unit generating the cryptographic stamp.<br/>
									3. Serial Number: Unique identifier for each invoicing device.
								</ng-container>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
								</svg>
							</div>
						</div>
					</div>					
					<div class="location_block">
						<fieldset class="">
							<input type="text" placeholder="Solution Name" formControlName="solution_name" class="serial-number" />
							<span class="field-error" *ngIf="(isSubmitted || f.solution_name.dirty) && f.solution_name.errors?.required" i18n="@@error.required" >Required</span>
							<span class="field-error" *ngIf="isSubmitted && f.solution_name.errors?.serverError">{{ f.solution_name.errors?.serverError }}</span>
						</fieldset>
						<fieldset class="">
							<input type="text" placeholder="Model" formControlName="model" class="serial-number" />
							<span class="field-error" *ngIf="(isSubmitted || f.model.dirty) && f.model.errors?.required" i18n="@@error.required" >Required</span>
							<span class="field-error" *ngIf="isSubmitted && f.model.errors?.serverError">{{ f.model.errors?.serverError }}</span>
						</fieldset>
						<fieldset class="">
							<input type="text" placeholder="Serial Number" formControlName="serial_number" class="serial-number" />
							<span class="field-error" *ngIf="(isSubmitted || f.serial_number.dirty) && f.serial_number.errors?.required" i18n="@@error.required" >Required</span>
							<span class="field-error" *ngIf="isSubmitted && f.serial_number.errors?.serverError">{{ f.serial_number.errors?.serverError }}</span>
						</fieldset>
					</div>
				</fieldset> -->

				<fieldset class="common-name oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.common_name?.dirty) && f.common_name.errors }">
					<div class="d-flex gap-2 align-items-center pointer">
						<ng-container i18n="@@zatca.company_name">Company name</ng-container><span class="req-star">*</span>
						<div class="tooltip_wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
								<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div class="help_tooltip_text">
								<ng-container i18n="@@zatca.common_name_tooltip">
									Usually VAT Number or Company Name.
								</ng-container>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
								</svg>
							</div>
						</div>
					</div>
					<input type="text" formControlName="common_name" class="common-name" />
					<span class="field-error" *ngIf="(isSubmitted || f.common_name.dirty) && f.common_name.errors?.required" i18n="@@error.required" >Required</span>
					<span class="field-error" *ngIf="isSubmitted && f.common_name.errors?.serverError">{{ f.common_name.errors?.serverError }}</span>
				</fieldset>

				<fieldset class="organization-name oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.organization_name?.dirty) && f.organization_name.errors }">
					<div class="d-flex gap-2 align-items-center pointer">
						<ng-container i18n="@@zatca.organization_name">Organization Name</ng-container><span class="req-star">*</span>
						<div class="tooltip_wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
								<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div class="help_tooltip_text">
								<ng-container i18n="@@zatca.organization_name_tooltip">
									Legal company name registered with ZATCA
								</ng-container>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
								</svg>
							</div>
						</div>
					</div>
					<input type="text" formControlName="organization_name" class="organization-name" />
					<span class="field-error" *ngIf="(isSubmitted || f.organization_name.dirty) && f.organization_name.errors?.required" i18n="@@error.required" >Required</span>
					<span class="field-error" *ngIf="isSubmitted && f.organization_name.errors?.serverError">{{ f.organization_name.errors?.serverError }}</span>
				</fieldset>

				<fieldset class="organization-unit-name oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.organizational_unit_name?.dirty) && f.organizational_unit_name.errors }">
					<div class="d-flex gap-2 align-items-center pointer">
						<ng-container i18n="@@zatca.organizational_unit_name">Organization Unit Name</ng-container><span class="req-star">*</span>
						<div class="tooltip_wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
								<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div class="help_tooltip_text">
								<ng-container i18n="@@zatca.organizational_unit_name_tooltip">
									A sub-unit or Department or system generating invoices in your organization.
								</ng-container>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
								</svg>
							</div>
						</div>
					</div>
					<input type="text" formControlName="organizational_unit_name" placeholder="Jeddah Branch" class="organization-unit-name" />
					<span class="field-error" *ngIf="(isSubmitted || f.organizational_unit_name.dirty) && f.organizational_unit_name.errors?.required" i18n="@@error.required" >Required</span>
					<span class="field-error" *ngIf="isSubmitted && f.organizational_unit_name.errors?.serverError">{{ f.organizational_unit_name.errors?.serverError }}</span>
				</fieldset>

				<!-- <fieldset class="address oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.address?.dirty) && f.address.errors }">
					<div class="d-flex gap-2 align-items-center pointer">
						<ng-container i18n="@@zatca.address">Address</ng-container><span class="req-star">*</span>
					</div>
					<input type="text" formControlName="address" placeholder="144 Street, Jeddah, Saudi Arabia" class="address" />
					<span class="field-error" *ngIf="(isSubmitted || f.address.dirty) && f.address.errors?.required" i18n="@@error.required" >Required</span>
					<span class="field-error" *ngIf="isSubmitted && f.address.errors?.serverError">{{ f.address.errors?.serverError }}</span>
				</fieldset> -->

				<fieldset class="serial-number oneThird" [ngClass]="{ 'has-error': (isSubmitted || (f.street?.dirty || f.building_number.dirty || f.city.dirty)) && (f.street.errors || f.building_number.errors || f.city.errors) }">
					<div class="d-flex gap-2 align-items-center pointer">
						<ng-container i18n="@@zatca.address">Address</ng-container><span class="req-star">*</span>
					</div>
					<div class="location_block">
						<fieldset class="">
							<input type="text" placeholder="Street" formControlName="street" class="street" />
							<span class="field-error" *ngIf="(isSubmitted || f.street.dirty) && f.street.errors?.required" i18n="@@error.required" >Required</span>
							<span class="field-error" *ngIf="isSubmitted && f.street.errors?.serverError">{{ f.street.errors?.serverError }}</span>
						</fieldset>										
						<fieldset class="">
							<input type="text" placeholder="Building Number" formControlName="building_number" class="building_number" />
							<span class="field-error" *ngIf="(isSubmitted || f.building_number.dirty) && f.building_number.errors?.required" i18n="@@error.required" >Required</span>
							<span class="field-error" *ngIf="isSubmitted && f.building_number.errors?.serverError">{{ f.building_number.errors?.serverError }}</span>
						</fieldset>
						<fieldset class="">
							<input type="text" placeholder="City" formControlName="city" class="city" />
							<span class="field-error" *ngIf="(isSubmitted || f.city.dirty) && f.city.errors?.required" i18n="@@error.required" >Required</span>
							<span class="field-error" *ngIf="isSubmitted && f.city.errors?.serverError">{{ f.city.errors?.serverError }}</span>
						</fieldset>
					</div>
				</fieldset>

				<fieldset class="business-category oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.business_category?.dirty) && f.business_category.errors }">
					<div class="d-flex gap-2 align-items-center pointer">
						<ng-container i18n="@@zatca.business_category">Business Category</ng-container><span class="req-star">*</span>
						<div class="tooltip_wrapper">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
								<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div class="help_tooltip_text">
								<ng-container i18n="@@zatca.business_category_tooltip">
									Your business category like food, real estate, etc
								</ng-container>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
									<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
								</svg>
							</div>
						</div>
					</div>
					<input type="text" formControlName="business_category" placeholder="Information Technology" class="business-category" />
					<span class="field-error" *ngIf="(isSubmitted || f.business_category.dirty) && f.business_category.errors?.required" i18n="@@error.required" >Required</span>
					<span class="field-error" *ngIf="isSubmitted && f.business_category.errors?.serverError">{{ f.business_category.errors?.serverError }}</span>
				</fieldset>
			</div>

			<div class="account-setting__actionButtonsWrap">
				<button i18n="@@zatca.generate_certificate" type="submit" class="tu-btn pink save-btn">Generate Certificate</button>
				<button i18n="@@common.back" type="button" class="tu-btn pink transparent" *ngIf="certificate?.organization_id" (click)="back()">Back</button>
			</div>
		</form>
	</ng-template>

</div>